module.exports = __webpack_public_path__ + "img/app-mockup-webapp.3411231e.png";